/*
 * @Description: 
 * @Version: 2.0
 * @Autor: chenkang
 * @Date: 2021-09-01 17:46:54
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2024-07-12 15:32:10
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http_pad';
import { type } from './interface';
import qs from 'qs';
export namespace TbNotice {
    /**
    * 通知公告详情
    */
    export var GetTbNoticeById = (body: any): Promise<any> => {
        return Get(`/api/TbNotice/GetTbNoticeById`, body);
    };
    /**
    * 通知公告
    */
    export var GetTbNoticeList = (body: any): Promise<any> => {
        return Get(`/api/TbNotice/GetTbNoticeList`, body);
    };

}



// WEBPACK FOOTER //
// ./src/http/api_TbNotice.ts